module.exports = __webpack_public_path__ + "static/media/most-transactions-season.03fcd2a7.png";